import React from 'react'
import { useTranslation } from 'react-i18next'

import MainChoices from './MainChoices'
import SmallLinkChoices from './SmallLinkChoices'

import UiContainer from '../../common-components/UiContainer'

const ActualCustomerPortalComponent = UiContainer()(props => (
  <div>
    <MainChoices {...props} />
    <SmallLinkChoices {...props} />
  </div>
))

export default props => {
  const { t } = useTranslation()
  return (
    <ActualCustomerPortalComponent
      {...props}
      uiContainerHocProps={{
        headerText: props.isEmployee ? t('employeePortal') : t('Customer Portal'),
        containerId: 'customerPortalSection',
      }}
    />
  )
}
